import difference from "lodash/difference";

const NON_FILTERS = [
  "endDate",
  "from",
  "size",
  "sortBy",
  "sortDir",
  "startDate",
  "submitted",
  "todo",
];

/**
 * Get all filter names and check for "live" filters
 *
 * This was extracted from actions/historyActions.js
 * and lives here for want of a better place.
 *
 * @param {object} filters
 * @return {boolean}
 */
export function hasNoLiveFilters(filters) {
  const keys = Object.keys(filters);

  // remove everything that's not really a filter
  const liveFilters = difference(keys, NON_FILTERS);

  // anything left is a live filter, so we don't show no-entry dates
  return liveFilters.length === 0;
}



// WEBPACK FOOTER //
// ./app/utils/filters.js